import { z } from "zod";

import { uuid } from "~/utils/schemas";

export const filterUuid = () => uuid().nullable();

/** URL/query filter arrays that allow null sentinel `sc_null` (saved-filter drawer contract). */
export const filterUuidArray = () => z.union([filterUuid(), z.literal("sc_null")]).array();

export const tagIdsTableFilterSchema = z.object({
  tagIdsIn: uuid().array(),
});

export const tagIdsFilterSchema = z.object({
  tagIdsIn: z.array(z.string().uuid("Tag ID is not a valid format")).optional(),
});

/**
 * Archived filter mode for index page filtering.
 * - "exclude": Show only active (non-archived) records (default)
 * - "include": Show both active and archived records
 * - "only": Show only archived records
 */
export const ArchivedFilterMode = z.enum(["exclude", "include", "only"]);
export type ArchivedFilterMode = z.infer<typeof ArchivedFilterMode>;

/** Schema fragment for archived filter in table filter forms */
export const archivedFilterSchema = z.object({
  archivedMode: ArchivedFilterMode.default("exclude"),
});

/**
 * Catalog / inventory list filter for product UN/NA assignment.
 * - "all": no UN constraint
 * - "hazardous": UN is set and is not the NON-HAZ sentinel
 * - "nonHazardous": UN is unset, blank, or explicitly NON-HAZ
 */
export const HazmatFilterMode = z.enum(["all", "hazardous", "nonHazardous"]);
export type HazmatFilterMode = z.infer<typeof HazmatFilterMode>;

export const hazmatFilterSchema = z.object({
  hazmatMode: HazmatFilterMode.default("all"),
});

/**
 * Toolbar "Hide archived" chip vs drawer Archived Records select.
 * Drawer include/only wins (chip is disabled in the UI); otherwise the chip maps to exclude/include.
 */
export function resolveArchivedModeFromHideChip(drawerMode: ArchivedFilterMode, hideArchived: boolean): ArchivedFilterMode {
  if (drawerMode !== "exclude") {
    return drawerMode;
  }
  return hideArchived ? "exclude" : "include";
}
